import { useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetReportFQNs = (id?: string) => {
  const { datasetId = id } = useParams();
  return useFetcher<string[]>(`${VITE_CATALOG_API}/datasets/${datasetId}/report-fqns`);
};

export default useDatasetReportFQNs;
